import React, { useEffect, useRef, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { LOGO, REPORT_TYPES } from "../../../../constants/app-constant";
import { getInlineFilterText, getSocialPlatformIdFromName, getTimelineText, getTimelineTextPosition } from "../../../../utility/common-methods";

const {
  JournalistNOARanking,
  JournalistAnalysisPrint,
  JournalistNOATrend,
  SOV_NOA_TREND,
  JournalistTonalityNOARanking,
  PublicationNOATrend,
  TonalityNAORanking,
  PublicationNOARanking,
  PublicationTonalityNOARanking,
  CityWiseNOARanking,
  CityWiseNOATrend,
  CityWiseTonality,
  StateWiseTonality,
  CityWiseCCMTonality,
  CityWiseMAVTonality,
  CityWiseCCMRanking,
  PLATFORM_RANK,
  Reach,
  PLATFORM_TREND,
  PLATFORM_TONALITY,
  TonalityNAOTrend,
  StateWiseTrend,
  TonalityWordCount,
  TonalityWCTrend,
  EditionWiseNOATrend,
  MediaWiseNOARanking,
  ThematicAnalysisTag,
  ThematicAnalysisEntity,
  ShareRetweet,
  ReplyComment,
  Attachment,
  Like,
  MemberType,
  TypeOfPost,
} = REPORT_TYPES;

const formatData = ({ datasets }) => {
  if (!datasets) return;
  return datasets
    .map((elm) => ({
      name: elm.label,
      data: elm.data && elm.data.map((el) => parseInt(el, 10)),
      color: elm.backgroundColor,
    }))
    .sort((a, b) => parseFloat(b.data) - parseFloat(a.data));
};
export const AreaChartHC = function ({
  graphApiResponse = { hcData: [{}] },
  onEntityClick,
  reportType,
  entityList,
  dataByReportType,
  editionList,
  isEmbededWidget,
  chartTitle,
  setGraphRef,
  setGraphRefList,
  mediaType,
  to_date,
  from_date,
  dateHash,
  widget,
  selectedInlineJournalist,
  selectedInlinePlatform,
  selectedInlinePublication,
  selectedInlineSentiment,
  isBlogAndForum,
  isSocial,
  selectedInlineWCType
}) {
  const ref = useRef();
  const [lineChartData, setLineChartData] = useState({});

  useEffect(() => {
    setGraphRef(ref);
  }, []);

  useEffect(() => {
    redrawChart();
  }, [graphApiResponse]);

  const redrawChart = () => {
    const options = {
      chart: {
        type: "area",
        animation: false,
      },
      title: {
        text: chartTitle,
        margin: 10,
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          color: "#666",
        },
      },
      exporting: {
        sourceWidth: 1200,
        chartOptions: {
          legend: {
            enabled: true,
            verticalAlign: "top",
            maxHeight: 1000,
            margin: 25,
            y: 70,
          },
          chart: {
            events: {
              load: function () {
                var renderer = this.renderer;
                renderer
                  .text(
                    `${getTimelineText(to_date,from_date,dateHash)}`,
                    getTimelineTextPosition(getTimelineText(to_date,from_date,dateHash)),
                    80
                  )
                  .add();
                renderer
                  .text(
                    `${getInlineFilterText(widget,selectedInlineJournalist,selectedInlinePlatform,selectedInlinePublication,selectedInlineSentiment,isBlogAndForum,isSocial,selectedInlineWCType)} `,
                    getTimelineTextPosition(getInlineFilterText(widget,selectedInlineJournalist,selectedInlinePlatform,selectedInlinePublication,selectedInlineSentiment,isBlogAndForum,isSocial,selectedInlineWCType)),
                    95
                  )
                  .add();
                renderer
                  .image(LOGO.biuLogoBase, 725, 10, 50, 50)
                  .attr({
                    align: "center",
                  })
                  .add();
              },
            },
          },
        },
      },
      series: formatData(graphApiResponse),
      plotOptions: {
        area: {
          marker: {
            symbol: "circle",
          },
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          fillOpacity: 0.2,
          label: {
            connectorAllowed: false,
          },
          events: {
            click: (e) => handlePointsClick(e),
          },
          pointStart: 0,
          lineWidth: 0.2,
        },
      },
      xAxis: {
        categories: graphApiResponse.labels,
        labels: {
          style: {
            fontSize: "8px",
            textOverflow: "none",
          },
        },
      },
      yAxis: {
        minPadding: 2,
        title: {
          text: null,
        },
      },
    };
    setLineChartData(options);
    if (setGraphRefList) {
      setGraphRefList(reportType + mediaType, ref);
    }
  };

  const handlePointsClick = (e) => {
    try {
      const {
        point: {
          category,
          series: { name },
        },
      } = e;
      const [label, legend] = [category, name];
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
      };
      let clickedEntity = label;
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOARanking ||
        reportType === JournalistNOATrend ||
        reportType === JournalistAnalysisPrint ||
        reportType === PublicationNOARanking ||
        reportType === PublicationNOATrend ||
        reportType === CityWiseNOATrend ||
        reportType === PLATFORM_RANK ||
        reportType === PLATFORM_TREND ||
        reportType === TonalityNAOTrend ||
        reportType === StateWiseTonality ||
        reportType === MediaWiseNOARanking ||
        reportType === ThematicAnalysisTag ||
        reportType === TonalityWCTrend ||
        reportType === ShareRetweet ||
        reportType === ReplyComment ||
        reportType === Attachment ||
        reportType === Like ||
        reportType === MemberType ||
        reportType === TypeOfPost
      ) {
        clickedEntity = legend;
      }
      if (
        reportType === SOV_NOA_TREND ||
        reportType === JournalistNOATrend ||
        reportType === JournalistAnalysisPrint ||
        reportType === PublicationNOATrend ||
        reportType === CityWiseNOATrend ||
        reportType === PLATFORM_TREND ||
        reportType == REPORT_TYPES.SOV ||
        reportType === TonalityNAOTrend ||
        reportType === StateWiseTonality ||
        reportType === EditionWiseNOATrend ||
        reportType === TonalityWCTrend
      ) {
        routeParams.date = label;
      }
      if (reportType === JournalistNOARanking) {
        routeParams.sourceName = label;
        if (isEmbededWidget) {
          let labelArray = label.split("[");
          routeParams.sourceName = labelArray
            .slice(0, labelArray.length - 1)
            .join("[");
        }
      }
      if (reportType === JournalistAnalysisPrint) {
        routeParams.sourceName = clickedEntity;
      }
      if (reportType === PublicationNOARanking) {
        const clickedPublication = dataByReportType.filter(
          (elm) => elm.publication_name == label
        )[0];
        routeParams.publication = clickedPublication;
      }
      if (reportType === ThematicAnalysisTag) {
        const clickedCategory = dataByReportType.filter(
          (elm) => elm.category_name == label
        )[0];
        routeParams.categoryId = clickedCategory.category_id;
      }
      if (reportType === ThematicAnalysisEntity) {
        const entityClicked = dataByReportType.filter(
          (elm) => elm.entity_name == label
        )[0];

        if (entityClicked && entityClicked.data && entityClicked.data.length) {
          const clickedCategory = entityClicked.data.filter(
            (elm) => elm.category_name == legend
          )[0];
          routeParams.categoryId = clickedCategory.category_id;
        }
      }
      if (
        reportType === CityWiseNOARanking ||
        reportType === EditionWiseNOATrend ||
        reportType === CityWiseCCMRanking
      ) {
        const clickedEdition = editionList.filter(
          (elm) => elm.edition_name == legend
        )[0];
        routeParams.edition = clickedEdition;
      }
      if (reportType === MediaWiseNOARanking) {
        const clickedEdition = editionList.filter(
          (elm) => elm.edition_name == label
        )[0];
        routeParams.edition = clickedEdition;
      }
      if (
        reportType === JournalistTonalityNOARanking ||
        reportType === TonalityNAORanking ||
        reportType === PublicationTonalityNOARanking ||
        reportType === CityWiseTonality ||
        reportType === StateWiseTonality ||
        reportType === CityWiseCCMTonality ||
        reportType === CityWiseMAVTonality ||
        reportType === TonalityWordCount ||
        reportType === PLATFORM_TONALITY
      ) {
        const tone = legend;
        routeParams.tonality = tone;
      }
      if (reportType == PLATFORM_RANK) {
        routeParams.channelType = getSocialPlatformIdFromName(label);
      }
      if (reportType == Reach) {
        routeParams.channelType = getSocialPlatformIdFromName(legend);
      }
      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_display_name?.trim() ||
            clickedEntity == elm.name || label == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <div className={isEmbededWidget ? "biggerWidget" : ""}>
      <HighchartsReact
        highcharts={Highcharts}
        options={lineChartData}
        ref={ref}
      />
    </div>
  );
};

AreaChartHC.defaultProps = {
  graphApiResponse: {},
  onEntityClick: () => {},
  reportType: "",
  entityList: [],
  dataByReportType: {},
  editionList: [],
  isEmbededWidget: false,
  chartTitle: "",
  setGraphRef: () => {},
  setGraphRefList: () => {},
};
